import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

import BlockBuilder from '../../BlockBuilder';
import SectionContainer from '../SectionContainer';
import css from './SectionLatestListings.module.css';
import { callToFetchLatestListings } from '../../../../util/api';
import { NamedLink } from '../../../../components';
import { FormattedMessage } from '../../../../util/reactIntl';

const SparkleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className={css.sparkle}>
    <path d="M24 12C17.7782 12 12 17.7782 12 24C12 17.7782 6.22183 12 0 12C6.22183 12 12 6.22183 12 0C12 6.22183 17.7782 12 24 12Z" fill="#8C265C"/>
  </svg>
);

const AccentTitle = ({ data }) => {
  if (!data?.content) return null;
  const parts = data.content.split(/\*\*(.*?)\*\*/g);
  return (
    <h2 className={css.title}>
      {parts.map((part, i) =>
        i % 2 === 1 ? <span key={i} className={css.titleAccent}>{part}</span> : part
      )}
    </h2>
  );
};

const ChevronLeft = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ChevronRight = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const SectionLatestListings = props => {
  const { sectionId, className, title, appearance, options } = props;
  const [blocks, setListings] = useState([]);
  const trackRef = useRef(null);

  useEffect(() => {
    callToFetchLatestListings().then(res => {
      const listings = res.listings.map(l => ({
        title: {},
        text: {},
        callToAction: {},
        media: {},
        alignment: 'center',
        blockType: 'defaultBlock',
        blockName: 'recommended-listing',
        content: l,
      }));
      setListings(listings);
    });
  }, []);

  const slide = dir => {
    if (!trackRef.current) return;
    const firstCard = trackRef.current.children[0];
    if (!firstCard) return;
    // 20px gap between cards
    const cardWidth = firstCard.offsetWidth + 10;
    trackRef.current.scrollBy({ left: dir * cardWidth, behavior: 'smooth' });
  };

  const fieldOptions = { fieldComponents: options?.fieldComponents };
  const hasBlocks = blocks.length > 0;

  return (
    <SectionContainer
      id={sectionId}
      rootClassName={css.root}
      className={className}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.container}>
        {title?.content ? (
          <div className={css.headerRow}>
            <div className={css.titleRow}>
              <AccentTitle data={title} />

              <NamedLink
                name="SearchPage"
                className={css.viewAll}
              >
                <FormattedMessage id="SectionLatestListings.viewAll" />
              </NamedLink>
            </div>
          </div>
        ) : null}

        {hasBlocks ? (
          <div className={css.carouselWrapper}>
            <button
              className={classNames(css.arrowBtn, css.arrowLeft)}
              onClick={() => slide(-1)}
              aria-label="Anterior"
            >
              <ChevronLeft />
            </button>

            <div className={css.track} ref={trackRef}>
              <BlockBuilder
                rootClassName={css.slide}
                blocks={blocks}
                sectionId={sectionId}
                responsiveImageSizes="(max-width: 767px) 100vw, 400px"
                options={options}
              />
            </div>

            <button
              className={classNames(css.arrowBtn, css.arrowRight)}
              onClick={() => slide(1)}
              aria-label="Siguiente"
            >
              <ChevronRight />
            </button>
          </div>
        ) : null}
      </div>
    </SectionContainer>
  );
};

export default SectionLatestListings;
